import React from 'react'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'
import { Cookie } from '@qureos/assets'
import Link from 'next/link'

interface CookieBannerProps {
  onAccept: () => void
}

export const CookieBanner: React.FC<CookieBannerProps> = ({ onAccept }) => {
  const { t: Label } = useTranslation('Cookie')
  const { t: Common } = useTranslation('common')
  return (
    <div
      role="banner"
      aria-label={Label('COOKIE_BANNER_TITLE')}
      className="fixed bottom-5 right-5 bg-white p-5 rounded-lg shadow-lg max-w-[500px] h-[88px] z-50 animate-slide-in flex items-center justify-center text-sm gap-x-2.5 border border-grayLight"
    >
      <div className="flex items-center justify-start gap-4">
        <div className="w-[43px] h-[40px] flex-shrink-0">
          <Image
            src={Cookie}
            alt={Label('COOKIE_ICON_ALT')}
            width={43}
            height={40}
            className="w-[43px] h-[40px]"
          />
        </div>
        <p className="text-sm leading-relaxed text-gray-600">
          {Label('COOKIE_BANNER_DESCRIPTION')}
          <Link href={`${process.env.APP_URL}/policies/cookie-policy`}>
            <a
              className="pl-1 underline text-qureosPrimary"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${Common('PRIVACY_POLICY')}`}
            >
              {Common('PRIVACY_POLICY')}
            </a>
          </Link>
          .
        </p>
      </div>
      <button
        onClick={onAccept}
        aria-label={Label('COOKIE_BANNER_BUTTON')}
        className="text-white transition-colors duration-200 rounded tex-sm w-28 h-9 bg-emerald-600"
      >
        {Label('COOKIE_BANNER_BUTTON')}
      </button>
    </div>
  )
}
